import { Box, Typography } from "@mui/material";
import { LandToken } from "../../types/LandToken";

type BlockLandPreviewProps = {
    land: LandToken | null;
};

const BlockLandPreview = ({ land }: BlockLandPreviewProps) => {
    if (!land) {return null;}

    return (
        <Box
            sx={{
                width: "100%",
                height: "90px",
                border: "1px solid black",
                borderRadius: "20px",
                padding: "13px",
                display: "flex",
                gap: "16px",
                alignItems: "center",
                mb: "16px",
            }}
        >
            <Box
                sx={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "4px",
                    overflow: "hidden",
                    flexShrink: 0,
                }}
            >
                <img
                    src={land?.content || "/placeholder-land.jpg"}
                    alt={land?.meta?.name || "Land"}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                />
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                    flex: 1,
                    minWidth: 0,
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "'IBM Plex Mono', monospace",
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "black",
                        textTransform: "uppercase",
                        lineHeight: "18px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    {land?.meta?.name || "LAND NAME"}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: "'IBM Plex Mono', monospace",
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#666666",
                        textTransform: "uppercase",
                        lineHeight: "18px",
                    }}
                >
                    {(() => {
                        try {
                            const location = typeof land?.meta?.location === 'string'
                                ? JSON.parse(land.meta.location)
                                : land?.meta?.location;
                            return `${location?.name || "Unknown"}, ${location?.country || "NA"}`;
                        } catch {
                            return "Location unavailable";
                        }
                    })()}
                </Typography>
            </Box>
        </Box>
    );
};

export default BlockLandPreview;
